import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FaqItem" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['FaqQuestion', { 'is-opened': _ctx.active }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
    }, [
      _createElementVNode("div", null, _toDisplayString(_ctx.question), 1 /* TEXT */),
      _createElementVNode("i", {
        class: _normalizeClass(["ToggleIconFaq", _ctx.active ? 'lnr-chevron-up' : 'lnr-chevron-down'])
      }, null, 2 /* CLASS */)
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      innerHTML: _ctx.answer,
      class: _normalizeClass(['FaqAnswer', { Hidden: !_ctx.active, 'is-opened': _ctx.active }])
    }, null, 10 /* CLASS, PROPS */, _hoisted_2)
  ]))
}